export class SorterReturnDetailsReportRowDto {
    id: number;
    deviceId: number;

    timestampUtc: string;
    patronBarcode: string;

    itemSuccess: boolean;
    itemBarcode: string;
    itemName: string;

    expectedBin: string;
    observedBin: string;
    boxId: string;

    deviceBranchId: number;
    deviceName: string;
    deviceBookmaticStatusId: number | null;
    deviceBookmaticStatusName: string;
    deviceLastStatusUpdateUtc: string | null;

    // display override
    itemSuccessDisplay: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/reports/sorter/sorter-return-details-report-row.dto.ts